import axiosInstance from '../../../../config/axiosInstance';
import { RoleValidation } from "../../views/Roles/Validation/RoleValidation";

const handleChange = (event, formData, setFormData) => {
  const { name, value } = event.target;
  setFormData({
    ...formData,
    [name]: value,
  });
};

const handleSubmit = async (event, formData, setFormData, setErrors,redirectCallback,redirectRoleList) => {
  
  event.preventDefault();
  const formErrors = RoleValidation(formData);
  setErrors(formErrors);
  if (Object.keys(formErrors).length === 0) {
    try {
      const CompanyID=localStorage.getItem("CompanyID");
      formData.HostCompanyID=CompanyID;
      const response = await axiosInstance.post(`/Setup/CreateRole`, formData);
      
      setFormData({
        RoleName: '',
      });
      redirectRoleList();
    } catch (error) {
      console.error('Error posting data:', error);
    }
  }
};

export { handleChange, handleSubmit };